import { VerificationTransactionDetailsState } from "@idw-types/state/verification-transaction-details-state";
import { VerificationTransactionDetailsActionTypes, VerificationTransactionDetailsActions } from "../actions/verification-transaction-details-actions";

export const initialVerificationTransactionDetailsState: VerificationTransactionDetailsState = {
    verificationTransactionDetailsData: {
        isLoading: false,
        verificationTransactionDetails: null
    }
}

export const verificationTransactionDetailsReducer = (
    state: VerificationTransactionDetailsState = initialVerificationTransactionDetailsState,
    action: VerificationTransactionDetailsActions
): VerificationTransactionDetailsState => {
    switch (action.type) {
        case VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA_LOADING:
            return {
                ...state,
                verificationTransactionDetailsData: {
                    ...(action.payload.isLoading
                        ? { ...initialVerificationTransactionDetailsState.verificationTransactionDetailsData }
                        : { ...state.verificationTransactionDetailsData }),
                    isLoading: action.payload.isLoading
                }
            };
        case VerificationTransactionDetailsActionTypes.SET_VERIFICATION_TRANSACTION_DETAILS_DATA:
            return {
                ...state,
                verificationTransactionDetailsData: {
                    verificationTransactionDetails: action.payload.verificationTransactionDetails,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};